import * as service from './services'
import to from 'await-to-js'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  async getEspecialidade ({dispatch, getters}, q) {
    const [error, response = { data: null }] = await to(service.getEspecialidades(q))
    if (error) {
      throw error
    }
    return response.data
  }
}



// WEBPACK FOOTER //
// ./src/store/especialidadeRede/index.js